<template>
  <div>
    <zj-layout-container>
      <zj-layout-main>
        <div class="zj-vehicleview-root select-none">
          <MapView MapKey="DefaultMap"></MapView>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import MapView from "./components/MapView";

export default {
  name: "IndexView",
  componentName: "IndexView",
  components: {
    MapView,
  },
  controller: "Home",
  action: "Index",
};
</script>

<style scoped>
.zj-vehicleview-root{
  height:100%;
  width: 100%;
}
</style>